import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import {
  useGetGroupOnlySupplierGroupsQuery,
  useGetPaymentandTermsQuery,
  useCreateSupplierGroupMutation
} from '../../../../store/api/supplier';
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1";
import Tab2 from './Tab2';
import { usePageState } from "../../../../Hook/usePageState";
function Supplier() {
  const navigate = useNavigate()
  const [res, setRes] = useState(false)
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error")
  const [selectedCompany, setSelectedCompany] = useState('')
  const [defaultaccount, setDefaultaccount] = useState('')
  const [showError, setShowError] = useState(false);
  const { data: supplierData, isEror, isLoading } = useGetGroupOnlySupplierGroupsQuery()
  const { data: paymentata, ispError, ispLoading } = useGetPaymentandTermsQuery()
  
  const [selectedCompanyAccounts, setSelectedCompanyAccounts] = useState([]);

  const [payment, setpayment] = useState([])
  const [supplier, setsupplier] = useState([])
  const [company, setCompany] = useState([])
  const [createSupplierGroup] = useCreateSupplierGroupMutation();
 const[status,setStatus] = useState(false)




 const pageStateDefault = {
         tab: 1,
         supplirGrpname: "",
         selectedSupplier: "",
         selectedpayment:'',
         isGroup:false,
         accounts:[{  company: "",
        account: ""}],
     
       };
     
       const [pageState, setPageState] = usePageState(`Create Supplier Group`, pageStateDefault);
     
     
       const { tab, supplirGrpname, selectedSupplier, selectedpayment, isGroup,accounts } = pageState;
       
  useEffect(() => {
    if (paymentata) {
      setpayment(paymentata.data)
    }
  }, [paymentata])

  useEffect(() => {
    if (supplierData) {
      setsupplier(supplierData.data);
    }
  }, [supplierData]);

  const handleSubmit = async () => {
    const payload = {
      supplier_group_name: supplirGrpname,
      parent_supplier_group: selectedSupplier,
      payment_terms: selectedpayment ? selectedpayment : "",
      is_group: isGroup,
      accounts: accounts
    };


    try {
      const response = await createSupplierGroup(payload).unwrap();
      console.log("Success:", response);
      setError('Supplier Group Created successfully!');
      setptype('Success');
      setStatus(true)
      setShowError(true);
      setTimeout(() => {
        navigate('/master/suppliergroup/supplier-list');
      }, 2000);

    } catch (error) {
      const parsedMessages = JSON.parse(error.data._server_messages); //
      const firstMessageObj = JSON.parse(parsedMessages[0]);
      console.log(firstMessageObj,"errr");
      setError(firstMessageObj.message);
   
      setptype('Error');
      setShowError(true);
    }
  };
  return (
    <>
      <FormLayoutTwo
        title="New Supplier Group"
        breadcrumbs={[
          { label: "Supplier Group" },
          { label: "Supplier Group List", url: "/master/suppliergroup/supplier-list" }
        ]}
        status={'hide'}
        actionButtons={
          <>
            <Button
              className="custom-btn-bluecolor d-flex"
              iconName="BiCloudUpload"
              style={{ gap: '2px' }}
              iconSize={14}
            >
              Upload
            </Button>
            <Button
              className="createbtn d-flex"
              style={{ gap: '2px', height: '28px' }}
              iconName="GrCopy"
              iconSize={12}
            >
              Duplicate
            </Button>
            <Button
              className="custom-btn-00989"
              iconName="LuFilePlus2"
              style={{ gap: '2px', height: '28px' }}
              onClick={handleSubmit}

              iconSize={12}
            // display={finalstep ? 'none' : 'flex'}
            >
              {/* {po_response.result ? 'Submit' : 'Save'} */}save
            </Button>

            <Button
              to="/brand/create-brand"
              className="px-2"
              imgSrc={printerimg}
              imgStyle={{ width: '21px' }}
            />
          </>
        }
      >
        <div className="" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
          <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
            <div className="d-flex justify-content-between align-items-end ">
              <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                  <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { setPageState({ ...pageState, tab: 1 })  }} href="javascript:void(0);">
                    General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                  </a>
                </li>
              </ul>
              <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: '12px' }}>
                <span style={{ position: "relative", top: "-1px" }}>
  <GetIcon className="text-[#4B002B]" iconName="CgAttachment" size={12} />
</span>
<span className="fw-semibold" style={{ color: "#4B002B" }}>
  Attachments
</span> 
              </div>
            </div>
          </div>

            <div className=" " style={{ background: '' }}>
                        <div className="row">
                            <div className="col-12">
                                <div className="sidebarbox m-0">
                                   <Tab1  

                                   selectedSupplier = {{
                      supplier: supplier,
                      value: pageState.selectedSupplier,
                      setValue: (val) => setPageState({ ...pageState, selectedSupplier: val }),
                      
                    }}
                                    supplirGrpname={{
                      value: pageState.supplirGrpname,
                      setValue: (val) => setPageState({ ...pageState, supplirGrpname: val }),
                      
                    }}
 selectedpayment = {{
                      payment: payment,
                      value: pageState.selectedpayment,
                      setValue: (val) => setPageState({ ...pageState, selectedpayment: val }),
                    }}
                    isGroup={{
                      value: pageState.isGroup,
                      setValue: (val) => setPageState({ ...pageState, isGroup: val }),
                      
                    }}

                                                                             
                                                                             
                                                  handleChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                                                    onInputChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                                                                      
                                                    />
                                   {/* <Tab1 supplier={supplier}
                    setsupplier={setsupplier}
                    setSelectedSupplier={setSelectedSupplier}
                    selectedSupplier={selectedSupplier}
                    supplirGrpname={supplirGrpname}
                    setSuppliergrpname={setSuppliergrpname}
                    payment={payment}
                    selectedpayment={selectedpayment}
                    setIsGroup={setIsGroup}
                    isGroup={isGroup}
                    setSelectedpayment={setSelectedpayment}
                  /> */}
                  <Tab2
                   pageState={pageState}
                                                                                    setPageState={setPageState}
                                                  handleChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                                                    onInputChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                                                    accounts={{
  value: pageState.accounts || [],
  setValue: (val) => setPageState({
    ...pageState,
    accounts: val,
  }),
}}
                                                                      
                    // setSelectedCompanyAccounts={setSelectedCompanyAccounts}
                  />
                                </div>
								
                                
                            </div>
                        </div>
                    </div>

        </div>
        <ApiResponseBox
          poptype={ptype}
          show={showError}
          errorMessage={error}
          onClose={() => setShowError(false)}
        />
      </FormLayoutTwo>
    </>
  )
}

export default Supplier
